<div class="bottom-back-odaring">
  <label (click)="clickNavigation();">
    {{'button.back.to' | translate}}
    <img src="assets/odaring-logo.svg" alt="odaring logo"/>
  </label>
</div>
